import React from "react";
import { Box, Badge, Button, Heading, Grid, Divider, useClipboard } from "@chakra-ui/core";
import "react-phone-input-2/lib/high-res.css";
import getFormattedAmount from "../../helpers/formatAmount";

/** Conllecting/Rendering info about the customer (buyers) */

const OrderDetailsView = ({ order }) => {
  const paymentLink = `${window.location.origin}/checkout/${order.ref}`;
  const { onCopy, hasCopied } = useClipboard(paymentLink);

  let variantColor = "";
  if (order.status === "paid") {
    variantColor = "success";
  } else if (order.status === "cancelled") {
    variantColor = "danger";
  } else if (order.status === "refunded") {
    variantColor = "warning";
  } else if (order.status === "processing") {
    variantColor = "gray";
  } else if (order.status === "pending") {
    variantColor = "blue";
  }  

  return (
    <>
      <Heading mb="20px" as="h4" size="md">
        Order
      </Heading>
      <Grid borderRadius="8px" bg="warning.transparent-100" templateColumns="repeat(2, 1fr)" gap="3px">
        <Box borderTopLeftRadius="5px" bg="warning.200" color="primary.500" w="100%" p="8px">
          Description{" "}
        </Box>
        <Box w="100%" p="8px" fontSize="sm">
          {order.description}{" "}
        </Box>
        <Box bg="warning.200" color="primary.500" w="100%" p="8px">
          Amount{" "}
        </Box>
        <Box w="100%" p="8px" fontSize="sm">
          {getFormattedAmount(order.amount)}
        </Box>
        <Box bg="warning.200" color="primary.500" w="100%" p="8px">
          Link{" "}
          <Button color="primary.500" bg="primary.transparent-300" _hover={{bg:"primary.transparent-500"}} size="xs" onClick={onCopy} ml={2}>
          {hasCopied ? "Copied" : "Copy"}
        </Button>
        </Box>
        <Box overflowX="auto" w="100%" p="8px" fontSize="sm">
            {paymentLink}
        </Box>
        <Box borderBottomLeftRadius="5px" bg="warning.200" color="primary.500" w="100%" p="8px">
          Status
        </Box>
        <Box w="100%" p="8px" fontSize="sm">
        <Badge variantColor={variantColor}>{order.status}</Badge>
        </Box>
      </Grid>
      <Divider my={6} />
    </>
  );
};

export default OrderDetailsView;
